import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 廊下自動生成確認ダイアログ
 * 3D移行時の自動チェック後表示（隣接していない部屋がある場合）
 */
class ConfirmGenerateHallwayDialog2 extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'confirmGenerateHallwayDialog';
    const title = '';

    let contents = '<div class="confirmGenerateHallway">\n';
    contents += '<span class="jp">隣接していない部屋があります。<br>廊下の自動生成を行いますか？</span><span class="en">Would you like to run the hallway generation?</span>';

    contents += '</div>\n';

    let footer = '<button value="true"><span class="jp">はい</span><span class="en">Yes</span></button>';
    footer += '<button><span class="jp">いいえ</span><span class="en">No</span></button>';

    this.createDialog(id, title, contents, footer);

    this.viewObj.querySelectorAll('button').forEach((element) => {
      element.addEventListener('click', this.btnEventHandler);
    });
  }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e) => {
      this.close();
      e.preventDefault();
      if ((e.currentTarget).value) {
        marietta.webcad.WebCADGlobal.cadAPIManager.generateHallways(() => {
          marietta.webcad.WebCADGlobal.dimensionMenu.checkModelParam(marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D);
          // marietta.webcad.WebCADGlobal.dimensionMenu.checkAutoFittings(() => {
          //   marietta.webcad.WebCADGlobal.dimensionMenu.checkModelParam(marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D);
          // });
        });
      } else {
        // 隣接していない部屋があります。 <br>間取りを修正してください。
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_HAS_SEPERATED_ROOM'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
        //    marietta.webcad.WebCADGlobal.dimensionMenu.checkAutoFittings(function(){
        //        marietta.webcad.WebCADGlobal.dimensionMenu.checkModelParam(marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D);
        //    });
      }
    }

  // /**
  // * model_paramの有無判別と処理s
  // */
  // checkModelParamExist = () =>{
  //     if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam) {
  //         marietta.webcad.WebCADGlobal.buildStyleManager.getList();
  //     } else {
  //         marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D();
  //     }
  //     this.close();
  // }
}
export default ConfirmGenerateHallwayDialog2;
